import { METHODS } from '../constants';
import utils from '../utils';

interface SystematicTransaction {
  systematicPlanId: string;
  investmentId: string;
  transactionAmount: string;
  stopReason: string;
  stopReasonDescription: string;
}
interface SystematicTransactionVerify {
  systematicPlanId: string;
  investmentId: string;
  otp: string;
  stopReason: string;
  stopReasonDescription: string;
}
const portfolioTransaction = () => ({
  //api call to get the systematic transactions for an investment ID
  getSystematicTransactions: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/systematic-transactions?investmentId=${investmentId}`),
  //api call to get the Banner
  getBannerDetails: () =>
    utils.fetch(`${process.env.HOST}/api/customer/overlay-banner-details`),
  //api call to get the systematic active upcoming transactions for an investment ID
  getSystematicActiveUpcomingTransactions: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/upcoming-active-transactions?investmentId=${investmentId}`),
  //api call to get the systematic active schedule transactions for an investment ID
  getSystematicActiveScheduleTransactions: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/scheduled-systematic-transactions?investmentId=${investmentId}`),
  //api call to get the systematic closed or expired transactions for an investment ID
  getSystematicClosedExpiredTransactions: (investmentId: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/closed-expired-transactions?investmentId=${investmentId}`),
  //api call to get the past 90 days transactions for an investment ID
  getPastTransactions: (investmentId: string, fromDate: string, toDate: string) => {
    let uri = `${process.env.HOST}/api/customer/past-mf-transactions?investmentId=${investmentId}`;
    if (fromDate && toDate) {
      uri = uri + `&fromDate=${fromDate}&toDate=${toDate}`
    }
    return utils.fetch(
      uri
    );
  },
  getStopTransactionOtp: (data: SystematicTransaction) =>
    utils.fetch(`${process.env.HOST}/api/transaction/stop/sip/otp`, { data: data, method: METHODS.POST }),
  getStopTransactionVerify: (data: SystematicTransactionVerify) =>
    utils.fetch(`${process.env.HOST}/api/transaction/stop/sip/otp/verify`, { data: data, method: METHODS.POST }),
  getLastTenTransaction: (investmentId: string, fundId: string, folioNumber: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/scheme-Folio-Transactions?investmentId=${investmentId}&fundId=${fundId}&folioNumber=${folioNumber}`),
  getActiveFundTransaction: (investmentId: string, fundId: string, folioNumber: string, scheduleDate: string) =>
    utils.fetch(`${process.env.HOST}/api/customer/active-fund-transaction?investmentId=${investmentId}&fundId=${fundId}&folioNumber=${folioNumber}&scheduleDate=${scheduleDate}`),

});

export default portfolioTransaction;
